import Entities from 'STORE';

export function resetHostConfig(): void {
  Entities.clientConfig.resetHostConfig();
}
